// "http://localhost:55459"
//https://b2badvertising.co.in/api
export const backendUrl = "/api";
export const imageUrl = "https://b2badvertising.co.in";